export default __webpack_public_path__ + "static/media/heroiccall.ec08e1ce.png";